module.exports = __webpack_public_path__ + "static/img/logo.17c2dd6e.png";